// extracted by mini-css-extract-plugin
export var parcelRow = "_sb-0";